import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import MountCustom from '../MountCustom'; 
import TestimonialCarousel from '../Testimonials/TestimonialCarousel';



const HookC = () => {
  const [action, setAction] = useState("Ghostwriter"); 
  const navigate = useNavigate(); 
  const handleHomeClick = () => {
    navigate('/home'); 
  };

  const handleDocumentPreparationClick = () => {
  navigate('/hookb'); // next card in sequence
};


  const handleConfidenceClick = () => {
    setAction("Confidence"); 
  };

  const isPrerendering = typeof window === 'undefined' || window.__PRERENDERING;
  if (typeof window === 'undefined' || isPrerendering) {
    return isPrerendering ? <div id="prerender-placeholder"></div> : null;
  }


  return (
    <div className='setter'>
      <Helmet>
        <title>{action === "Ghostwriter" ? "Private Ghostwriter" : "Professional Support"} - Contranorm Media & Production</title>
      </Helmet>
       <div className="background-avatar-cow">
          
        </div>
        <MountCustom>
          <div className="page">
            <h1>
              <div className="redRock">{action === "Ghostwriter" ? "Private Ghostwriter" : "Professional Support"}</div>
            </h1>
            <h3> {action === "Ghostwriter" ? "Not Quite Sure What to Do Next?" : "We Do the Work for You."}</h3>
            <div className="underline"></div>
              <>
                {action === "Ghostwriter" ? (
                 
                    <p>
                      From revision to submission: e-books, trademarks, grants, legal documents, and academic essays.
                      Our project managers handle the heavy lifting so you don’t have to—saving you time and unnecessary delays.
                    </p>

                
                  ) : (
                 
                    
                    
                     <p>
                      Kick things off right by providing complete documentation and clear instructions upfront. Once the initial quote is paid, we take it from there.
                      
                      Review, refine, and approve your project with ease. Your professional dashboard gives you full visibility and Live Chat features.
                    </p>


                
                )}
                <TestimonialCarousel display="hookC"/>
                <div className="submit-container">
                    {action === "Ghostwriter" ? (
                      <>
                         <Link to="/price-calculator" className="submit gray">Get Started</Link>
                        <div className="submit" onClick={handleConfidenceClick}>Learn More</div> 
                      </>
                      ) : (
                      <>
                        <div className="submit gray" onClick={handleDocumentPreparationClick}>Go Back</div>
                        <Link to="/price-calculator" className="submit">Get Started</Link>
                      </>
                    )}
                  </div>
              
            </>
          </div>
      </MountCustom>  
    </ div>
  );
};

export default HookC;
